import { call, getContext, takeEvery, put } from 'redux-saga/effects';
import BasketAPI from '../../../api/basket/BasketAPI';
import { basketActions } from '../actions/BasketActions.creators';
import { BasketActionTypes } from '../../../enums/ActionEnums';
import { BasketMergeTypes } from '@as-react/common-types';
export function* mergeBaskets(action) {
    try {
        const { defaultRequestParams, servicesEndpoint } = yield getContext('aemConfiguration');
        if (action.payload.type === BasketMergeTypes.PERSONAL_SHOPPING_ADVICE) {
            yield call(BasketAPI.personalShoppingAdviceMerge, action.payload.basketToken, servicesEndpoint, defaultRequestParams);
        }
        else {
            yield call(BasketAPI.merge, action.payload.basketToken, servicesEndpoint, defaultRequestParams);
        }
        yield put(basketActions.createGetAction());
    }
    catch (_a) { }
}
export function* mergeBasketsSaga() {
    yield takeEvery(BasketActionTypes.MERGE, mergeBaskets);
}
